import React from 'react';
import {
  Box,
//   Paper,
  Avatar,
  Typography,
  Stack,
//   Button,
  Chip,
  Divider,
  Grid,
  Alert,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
//   FaArrowLeft,
  FaEdit,
  FaShieldAlt,
  FaUserShield,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaBuilding,
  FaCheckCircle,
  FaTimesCircle,
  FaLeaf,
  FaInfoCircle
} from 'react-icons/fa';

const roleColors = {
  admin: 'success',
  user: 'primary',
  specialist: 'info',
  ngo: 'secondary',
  support: 'info'
};

const statusColors = {
  active: 'success',
  inactive: 'error'
};

export default function ProfileDetails({ user }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (

    <Box direction="row" spacing={2} alignItems="center" flexWrap="wrap" sx={{width: isMobile ? '90vw' : '40vw'}}>
      <Stack alignItems="center" spacing={2} sx={{ mt: 2, mb: 3 }}>
        <Avatar
          src={user.profile}
          alt={user.name}
          sx={{
            width: 110,
            height: 110,
            border: '4px solid #43a047',
            boxShadow: 3,
            bgcolor: '#e0f2f1',
          }}
        >
          <FaUser size={60} color="#43a047" />
        </Avatar>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ color: '#1976d2', fontFamily: 'Playfair Display' }}
        >
          {user.name}
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
          <Chip
            icon={<FaLeaf color="#43a047" />}
            label={user.role?.charAt(0).toUpperCase() + user.role?.slice(1)}
            color={roleColors[user.role] || 'default'}
            sx={{
              fontWeight: 'bold',
              fontSize: 15,
              bgcolor: '#e8f5e9',
              color: '#388e3c',
              px: 1.5,
            }}
          />
          <Chip
            icon={
              user.status === 'active'
                ? <FaCheckCircle color="#43a047" />
                : <FaTimesCircle color="#d32f2f" />
            }
            label={user.status?.charAt(0).toUpperCase() + user.status?.slice(1)}
            color={statusColors[user.status] || 'default'}
            sx={{
              fontWeight: 'bold',
              fontSize: 15,
              bgcolor: user.status === 'active' ? '#e8f5e9' : '#ffebee',
              color: user.status === 'active' ? '#388e3c' : '#d32f2f',
              px: 1.5,
            }}
          />
        </Stack>
      </Stack>

      { user?.deactivation_reason && (
        <>

        <Typography variant="body1" fontWeight="bold">Deactivation Reason:</Typography>
        <Alert
          severity="warning"
          icon={<FaInfoCircle />}
          sx={{ mx: isMobile ? 1 : 3, my: 2, fontStyle: 'italic' }}
        >
          {user.deactivation_reason}
        </Alert>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1" fontWeight="bold">Deactivated On:</Typography>
                <Typography variant="body2" sx={{ ml: 4, color: '#1976d2', wordBreak: 'break-all' }}>
                {user.deactivated_at ? new Date(user.deactivated_at).toLocaleDateString() : 'N/A'}{'  '}
            </Typography>
            {'  ||  '}
                <Typography variant="body1" fontWeight="bold">Type:</Typography>
                <Typography variant="body2" sx={{ ml: 4, color: '#1976d2', wordBreak: 'break-all' }}>
                    {user.deactivation_type || 'N/A'}
                </Typography>
            </Stack>
            
            
        </>
      )}

      <Divider sx={{ my: 3, borderColor: '#b2dfdb' }} />

      {/* User Info */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaEnvelope color="#1976d2" />
            <Typography variant="body1" fontWeight="bold">Email:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#1976d2', wordBreak: 'break-all' }}>
            {user.email}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaPhone color="#388e3c" />
            <Typography variant="body1" fontWeight="bold">Phone:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#388e3c' }}>
            {user.phone || <span style={{ color: '#888' }}>Not Provided</span>}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaBuilding color="#388e3c" />
            <Typography variant="body1" fontWeight="bold">Organisation:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#388e3c' }}>
            {user.organisation || <span style={{ color: '#888' }}>N/A</span>}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaBuilding color="#388e3c" />
            <Typography variant="body1" fontWeight="bold">County:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#388e3c' }}>
            {user.county || <span style={{ color: '#888' }}>N/A</span>}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaShieldAlt color="#1976d2" />
            <Typography variant="body1" fontWeight="bold">User ID:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#1976d2' }}>
            {user.id}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaUserShield color="#388e3c" />
            <Typography variant="body1" fontWeight="bold">Joined:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#388e3c' }}>
            {user.added_at ? new Date(user.added_at).toLocaleDateString() : 'N/A'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FaEdit color="#1976d2" />
            <Typography variant="body1" fontWeight="bold">Last Updated:</Typography>
          </Stack>
          <Typography variant="body2" sx={{ ml: 4, color: '#1976d2' }}>
            {user.updated_at ? new Date(user.updated_at).toLocaleDateString() : 'N/A'}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
